import React, { useEffect } from "react";
import QuickSightEmbedProgrammaticFiltering from "./QuickSightEmbedProgrammaticFiltering";
import QuickSightEmbedPlatform from "./QuickSightEmbedPlatform";

export default function QuickSightRouter({ content, config, setError }) {
  useEffect(() => {
    if (!content?.config?.provider) {
      setError("Provider type does not exist.");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content?.config?.provider]);

  return (
    <>
      {config?.type === "IFRAME_EMBED" && <QuickSightEmbedProgrammaticFiltering content={content} />}
      {config?.type === "JWT_FULL_EMBED" && <QuickSightEmbedPlatform content={content} />}
    </>
  );
}
